// This file was automatically generated from render.reqActFeedItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.reqActFeedItem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.button');
goog.require('el8.template.ptdata.letterReceipts');
goog.require('el8.template.ptdata.letters');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.render.chartFeedItem');
goog.require('el8.template.render.messageThreadContent');
goog.require('el8.template.render.reqActFeedItem');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.reportItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append((opt_data.report.reportType == 'lab') ? '<div class="el8FeedItemIconLab"></div>' : (opt_data.report.reportType == 'hospital') ? '<div class="el8FeedItemIconHospital"></div>' : (opt_data.report.reportType == 'imaging') ? '<div class="el8FeedItemIconImaging"></div>' : (opt_data.report.reportType == 'cardiac') ? '<div class="el8FeedItemIconCardiac"></div>' : (opt_data.report.reportType == 'legal') ? '<div class="el8FeedItemIconLegal"></div>' : (opt_data.report.reportType == 'consultation') ? '<div class="el8FeedItemIconConsult"></div>' : '<div class="el8FeedItemIconReport"></div>', '</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><a class="details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.ptdata.reports.feedSummary(opt_data.report, output);
  output.append('</a>', (opt_data.report.reviewUserName) ? '<span class="el8LeftIndent el8SystemText">(assigned to ' + soy.$$escapeHtml(opt_data.report.reviewUserName) + ')</span>' : '', '</p>');
  el8.template.ptdata.reports.noteListSummary(opt_data.report, output);
  if (opt_data.referringThreads.length > 0) {
    output.append('<p class="el8GrayText el8ItalicText">');
    var threadList30471 = opt_data.referringThreads;
    var threadListLen30471 = threadList30471.length;
    for (var threadIndex30471 = 0; threadIndex30471 < threadListLen30471; threadIndex30471++) {
      var threadData30471 = threadList30471[threadIndex30471];
      el8.template.ptdata.model.message.referencedFeedSummary(threadData30471, output);
    }
    output.append('</p>');
  }
  output.append((opt_data.isPhysician && el8Globals.FEATURES.Letters) ? '<div class="el8InlineDialogContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="chartSignOffTrigger el8PrimaryButton ebs-btn ebs-btn-primary" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Sign Off</button></li>' + ((el8Globals.FEATURES.PatientPortal) ? '<li class="el8ButtonItem"><button type="button" class="send-report-patient-trigger el8SecondaryButton ebs-btn ebs-btn-default" data-id="' + soy.$$escapeHtml(opt_data.report.id) + '">Sign Off &amp; Send to Patient</button></li>' : '') + '<li class="el8ButtonItem"><button type="button" class="send-report-consultant-trigger el8SecondaryButton ebs-btn ebs-btn-default" data-id="' + soy.$$escapeHtml(opt_data.report.id) + '">Sign Off &amp; Send to Provider</button></li></ul></div>' : '', '</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.orderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-higlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconOrder"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><span class="el8GenTagItem el8TagItem mr5">In Progress</span><a class="unsigned-order-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  if (opt_data.order.modelClass == 'ReferralOrder') {
    el8.template.ptdata.model.order.referral.feedSummary({order: opt_data.order}, output);
  } else {
    output.append((soy.$$escapeHtml(opt_data.order.orderType)? soy.$$escapeHtml(opt_data.order.orderType).capitalize() : ''), ': ');
    el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.order}, output);
  }
  output.append('</a></p></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.medOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconRx"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  el8.template.ptdata.model.medOrder.feedSummary(soy.$$augmentData(opt_data.order, {feedItemId: opt_data.feedItemId, hasActions: opt_data.hasActions}), output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.rxRefillRequestMedicationHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.refillMedication.requestedMedicationName), ' ', (opt_data.refillMedication.directions) ? 'sig: ' + soy.$$escapeHtml(opt_data.refillMedication.directions) : '', (opt_data.refillMedication.quantity) ? ' #' + soy.$$escapeHtml(opt_data.refillMedication.quantity) : '', (opt_data.refillMedication.isPrn) ? ' RFx(PRN)' : (opt_data.refillMedication.requestedRefills > 0) ? ' RFx' + soy.$$escapeHtml(opt_data.refillMedication.authRefills) : '', (opt_data.refillMedication.displaySubstitutions) ? ' ' + soy.$$escapeHtml(opt_data.refillMedication.displaySubstitutions) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.rxRefillRequestMedication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8GrayText el8ItalicText">Medication ', soy.$$escapeHtml(opt_data.medType), ':</p><p class="el8FeedItemHeader"><a class="rx-refill-detail-trigger el8TriggerLink" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.render.reqActFeedItem.rxRefillRequestMedicationHeader({refillMedication: opt_data.refillMedication}, output);
  output.append('</a></p>', (opt_data.refillMedication.note) ? '<p>Pharmacy Note: ' + soy.$$escapeHtml(opt_data.refillMedication.note) + '</p>' : '', (opt_data.refillMedication.writtenDate || opt_data.refillMedication.lastFillDate) ? '<div class="el8Spacer">' + ((opt_data.refillMedication.writtenDate || opt_data.refillMedication.lastFillDate) ? '<p>Script' + ((opt_data.refillMedication.writtenDate) ? ' written on ' + soy.$$escapeHtml(opt_data.refillMedication.writtenDate) : '') + ((opt_data.refillMedication.lastFillDate) ? ((opt_data.refillMedication.writtenDate) ? ' and' : '') + ' was last filled on ' + soy.$$escapeHtml(opt_data.refillMedication.lastFillDate) : '') + '.</p>' : '') + '</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.rxRefillRequest = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconRx"></div></div><div class="el8FeedItemContainer" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><span class="el8TagItem mr5">Refill Request</span>', (opt_data.isControlled) ? '<span class="el8TagItem mr5">Controlled Substance</span>' : '', '<a class="rx-refill-detail-trigger el8TriggerLink" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.render.reqActFeedItem.rxRefillRequestMedicationHeader({refillMedication: opt_data.dispensedMedication}, output);
  output.append('</a> <span class="el8SystemText">(assigned to ', soy.$$escapeHtml(opt_data.prescriberName), ')</span></p><p class="el8Spacer5">Refill Request From ', soy.$$escapeHtml(opt_data.pharmacyName), (opt_data.pharmacyPhone) ? ' (Ph: ' + soy.$$escapeHtml(opt_data.pharmacyPhone) + ')' : '', '</p>');
  el8.template.render.reqActFeedItem.rxRefillRequestMedication({medType: 'Prescribed', refillMedication: opt_data.prescribedMedication, feedItemId: opt_data.feedItemId}, output);
  el8.template.render.reqActFeedItem.rxRefillRequestMedication({medType: 'Dispensed', refillMedication: opt_data.dispensedMedication, feedItemId: opt_data.feedItemId}, output);
  if (opt_data.originalMedOrder) {
    output.append('<p class="el8GrayText el8ItalicText">Original Prescription Written:</p><p><a class="details-trigger" _fid="MedOrder_', soy.$$escapeHtml(opt_data.originalMedOrder.id), '">');
    el8.template.ptdata.model.medOrder.baseSummary(opt_data.originalMedOrder, output);
    output.append('</a></p>');
  }
  output.append((! opt_data.dispensedAsPrescribed) ? '<p>* Medication may not have been dispensed as prescribed. *</p>' : '', (opt_data.userCanAddress) ? '<div class="el8InlineDialogContainer"><ul class="el8ButtonContainer">' + ((opt_data.isReadyToAccept) ? '<li class="el8ButtonItem"><button type="button" class="rx-refill-approve-trigger el8PrimaryButton ebs-btn ebs-btn-primary" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Approve</button></li>' : '') + '<li class="el8ButtonItem"><button type="button" class="rx-refill-edit-trigger el8SecondaryButton ebs-btn ebs-btn-default" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Change Number of Refills</button></li><li class="el8ButtonItem"><button type="button" class="rx-refill-deny-trigger el8SecondaryButton ebs-btn ebs-btn-default" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + ((opt_data.isControlled) ? 'Deny or Replace' : 'Deny') + '</button></li></ul><div class="rx-refill-edit-detail"></div><div class="rx-refill-deny-detail"></div></div>' : '', '</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.rxHistoryDownload = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconDocMed"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><a class="view-fills-trigger" data-id="', soy.$$escapeHtml(opt_data.summaryItem.id), '">', soy.$$escapeHtml(opt_data.summaryItem.description), '</a></p>', (opt_data.summaryItem.eligPbmName) ? '<p class="el8GrayText">Source: Patient\'s Pharmacy Benefits Manager ' + soy.$$escapeHtml(opt_data.summaryItem.eligPbmName) + '</p>' : '', '</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.visitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconNote"></div></div><div class="el8FeedItemContainer"><p class="el8FeedItemHeader">', (opt_data.bill && opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.UnresolvedError) ? '<span class="el8AlertTagItem el8TagItem mr5">Bill Failed</span>' : '', (! opt_data.signDate) ? '<span class="el8GenTagItem el8TagItem mr5">In Progress</span>' : '', (! opt_data.signDate) ? '<a class="visit-note-trigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + soy.$$escapeHtml(opt_data.description) + '</a><span class="el8PhysicianNameSnippet"> for ' + soy.$$escapeHtml(opt_data.physicianFullName) + '</span>' : '<a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' + soy.$$escapeHtml(opt_data.description) + '</a>', '</p>', (opt_data.headerSummary) ? '<p class="el8DescriptionSnippet el8AppText">' + soy.$$escapeHtml(opt_data.headerSummary) + '</p>' : '');
  if (opt_data.bill && opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.UnresolvedError) {
    output.append('<div class="el8FeedItemActionContainer">');
    el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
    output.append('</div><p class="bill-error-text el8DescriptionSnippet">Error: ', soy.$$escapeHtml(opt_data.bill.billingError), '</p>');
  }
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.visitNoteEdit = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconNote"></div></div><div class="el8FeedItemContainer"><p class="el8FeedItemHeader"><span class="el8GenTagItem el8TagItem mr5">In Progress</span><a class="visit-note-edit-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">', soy.$$escapeHtml(opt_data.description), '</a></p></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.messageThread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconMessage"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  el8.template.render.messageThreadContent.content(opt_data, output);
  output.append((opt_data.isPostDated) ? '<p class="headerNote el8AlignRight">Message will be delivered on ' + (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.deliveryDate)) : '') + '</p>' : '');
  if (opt_data.signOffUser) {
    el8.template.render.signOff.summary(soy.$$augmentData(opt_data, {signUserName: opt_data.signOffUser}), output);
  } else {
    output.append((! el8Globals.READ_ONLY) ? '<div id="threadReplyTrigger_' + soy.$$escapeHtml(opt_data.id) + '" class="threadReplyTrigger el8FieldTrigger el8StandardFontSize" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Reply...</div>' : '', '<div class="threadPane_', soy.$$escapeHtml(opt_data.id), '"></div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.nonvisitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconNote"></div></div><div class="el8FeedItemContainer"><p class="el8FeedItemHeader"><span class="el8GenTagItem el8TagItem mr5">In Progress</span><a class="nonvisit-note-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">', soy.$$escapeHtml(opt_data.description), '</a></p></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.incomingDirectMessage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight direct-message-item" data-id="', soy.$$escapeHtml(opt_data.directMessage.id), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.appshared.docTags.feedIcon(opt_data, output);
  output.append('</div><div class="el8FeedItemContainer"><p class="el8FeedItemHeader"><span class="el8GenTagItem el8TagItem mr5">');
  el8.template.ptdata.model.note.nonvisitNoteDescription(opt_data, output);
  output.append('</span>');
  el8.template.render.reqActFeedItem.nonvisitNoteCore(opt_data, output);
  output.append('<!--<a class="nonvisit-note-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">', soy.$$escapeHtml(opt_data.content), '</a></p>--></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.letterItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover', (opt_data.letter.signDate) ? ' el8LetterItem' : '', ' am-highlight letter-item" data-id="', soy.$$escapeHtml(opt_data.letter.id), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append((! opt_data.letter.signDate) ? (opt_data.letter.isSendToPatient) ? '<div class="el8FeedItemIconPtLetter"></div>' : (opt_data.letter.isReferralLetter) ? '<div class="el8FeedItemIconReferral"></div>' : '<div class="el8FeedItemIconLetter"></div>' : '', '</div><div class="el8FeedItemContainer">');
  if (! opt_data.letter.signDate) {
    output.append('<div class="el8FeedItemActionContainer">');
    el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
    output.append('</div><p class="el8FeedItemHeader"><span class="el8GenTagItem el8TagItem mr5">In Progress</span><a class="unsigned-letter-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
    el8.template.ptdata.letters.reqActSummaryUnsigned(opt_data, output);
    output.append('</a></p>');
  } else {
    output.append('<div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
    el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
    output.append('</div><div class="el8FeedIconContainer">');
    el8.template.ptdata.letters.feedIcon(opt_data.letter, output);
    el8.template.ptdata.letters.letterMetadataCounts(opt_data.letter, output);
    output.append('</div>');
    el8.template.ptdata.letters.signedSummary(soy.$$augmentData(opt_data, {noHighlight: true}), output);
    output.append('</div>');
    el8.template.ptdata.letters.secondarySection(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.unreadLetterNotificationItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight unread-letter-notification-item" data-id="', soy.$$escapeHtml(opt_data.unreadLetterNotification.id), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.appchart.letters.unreadAlertNotification.feedIcon({isSendToPatient: opt_data.letter.isSendToPatient, isReferralLetter: opt_data.letter.isReferralLetter}, output);
  output.append('</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader el8Ellipsis">Not opened by recipient -- ');
  el8.template.appchart.letters.unreadAlertNotification.feedSummary(soy.$$augmentData(opt_data, {linkToDetail: true}), output);
  output.append('</p><p class="el8DescriptionSnippet el8AppText">');
  el8.template.appchart.letters.unreadAlertNotification.unsignedSummary(opt_data, output);
  output.append('</p></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.letterReceipt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover el8NoMarginItem am-highlight letter-receipt-item" data-id="', soy.$$escapeHtml(opt_data.letterReceipt.id), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('</div><div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.ptdata.letterReceipts.feedIcon(opt_data.letterReceipt, output);
  el8.template.ptdata.letterReceipts.metadataCounts(opt_data.letterReceipt, output);
  output.append('</div>');
  el8.template.ptdata.letterReceipts.summary(soy.$$augmentData(opt_data.letterReceipt, {noHighlight: true}), output);
  output.append('</div>');
  el8.template.ptdata.letterReceipts.secondarySection(soy.$$augmentData(opt_data.letterReceipt, {noHighlight: true}), output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.xmlSummaryItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItem.xmlSummaryItem(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItem.hl7MessageItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItem.hl7MessageItem(opt_data, output);
  if (!opt_sb) return output.toString();
};
